import { MenuItem } from "@app/types";
import { NavLink } from "react-router-dom";

interface MenuItemProps extends MenuItem {
  className?: string;

  labelClassName?: string;
}

function MenuLinkItem({
  linkTo,
  label,
  icon,
  className = "",
  labelClassName = "",
}: MenuItemProps) {
  return (
    <NavLink
      to={linkTo}
      className={({ isActive }) => {
        let classNames = `h-14 px-5 flex items-center rounded-xl hover:bg-[#6f87ff] [&_.label]:hover:text-white [&_.fill]:hover:fill-white [&_.stroke]:hover:stroke-white ${className} `;

        if (isActive) {
          classNames +=
            "text-white bg-color-primary [&_.fill]:fill-white [&_.stroke]:stroke-white";
        }

        return classNames;
      }}
    >
      <div className="mr-4">{icon}</div>
      <div className={`label tracking-[0.024px] ${labelClassName}`}>
        {label}
      </div>
    </NavLink>
  );
}

export default MenuLinkItem;
